import { GRAY5 } from "../../../../constant/colors";

const cellStyle = { width: "265px", padding: "0" };
const cellLeftPaddingStyle = { ...cellStyle, paddingLeft: "15px" };
const cellWithBorderStyle = { width: "265px", padding: "0", borderRight: `1px solid ${GRAY5}` };
const cellWithLeftBorderStyle = { ...cellStyle, paddingLeft: "15px", borderLeft: `1px solid ${GRAY5}` };
const cellLeftPaddingBorderStyle = { ...cellLeftPaddingStyle, borderRight: `1px solid ${GRAY5}` };

const styles = {
  cellStyle,
  cellLeftPaddingStyle,
  cellWithBorderStyle,
  cellWithLeftBorderStyle,
  cellLeftPaddingBorderStyle
};

export default styles;
